module.exports = __webpack_public_path__ + "images/03c1c53.png";